import { BlobActions } from './actions';
import { IBlobState, initialBlobState } from './state';

export function blobReducer(state = initialBlobState, action: BlobActions): IBlobState {
  switch (action.type) {
    default:
      return state;
  }
}
